type Step = {
  id?: string | number;
  sourceId?: string;
  blocking?: boolean;
  backendLocked?: boolean;
};

const key = (step: Step) => step.sourceId ?? String(step.id);

/** A previous completion never overrides a current prerequisite or server lock. */
export function sequenceStatus(
  steps: Step[], index: number, completed: Set<string>, chapterOpen = true, testMode = false,
): 'locked' | 'available' | 'completed' {
  const item = steps[index];
  if (!item || !chapterOpen || item.backendLocked) return 'locked';
  if (!testMode && steps.slice(0, index).some(step => step.blocking && !completed.has(key(step)))) return 'locked';
  return completed.has(key(item)) ? 'completed' : 'available';
}
